// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"7b7701e385ffe6c9","4086":"3f1b0bca3dd92abd","9604":"012c0fd016fd8aa8","9625":"012c0fd016fd8aa8"}[chunkId] + ".css";
};